import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const WellnessClear = forwardRef<SVGSVGElement, SvgIconProps>(
  function WellnessClear(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m12.58563,4.55675c2.103,-2.198 5.513,-2.198 7.617,0c2.103,2.2 2.103,5.763 0,7.96l-8.203,8.575l-8.203,-8.574c-2.102,-2.198 -2.102,-5.762 0,-7.96c2.105,-2.199 5.515,-2.199 7.618,0l0.585,0.611l0.586,-0.612zm0.459,4.162l-2.09,0l0,1.955l-1.955,0l0,2.09l1.938,0l0,1.955l2.107,0l0,-1.956l1.955,0l0,-2.089l-1.955,0l0,-1.955z" />
      </SvgIcon>
    )
  },
)

export default WellnessClear
